<div *ngIf="isCreator && project.deadlineDelayRequest">
  <div class="flex flex-wrap align-items-center gap-3">
    <p class="line-through">
      {{ project.deadline ? (project.deadline | date: 'EEE, dd MMMM yyyy') : 'Отсутствует' }}
    </p>

    <crm-datepicker
      [disabled]="loading"
      [(value)]="formDeadline.deadline"></crm-datepicker>

    <div *ngIf="!loading">
      <i
        class="pi pi-check frm-color-green hover:text-green-300 cursor-pointer mr-2"
        (click)="acceptNewDate()"></i>
      <i
        class="pi pi-times text-color-secondary hover:frm-color-blue-light cursor-pointer ml-2"
        (click)="cancelNewDate()"></i>
    </div>
  </div>
  <div
    class="flex"
    [class.justify-content-end]="isTextRight">
    <div
      class="text-gray-400 flex-none"
      [innerHtml]="project.deadlineDelayRequest.commentary | truncate: 60:true | safeHtml"
      [pTooltip]="project.deadlineDelayRequest.commentary"
      tooltipPosition="bottom"
      [escape]="false"></div>
  </div>
</div>

<div *ngIf="isResponsible && project.deadlineDelayRequest">
  <div class="flex flex-wrap align-items-center gap-3">
    <p class="line-through">
      {{ project.deadline ? (project.deadline | date: 'EEE, dd MMMM yyyy') : 'Отсутствует' }}
    </p>

    <p>
      {{
        project.deadlineDelayRequest?.deadline
          ? (project.deadlineDelayRequest.deadline | date: 'EEE, dd MMMM yyyy')
          : 'Отсутствует'
      }}
    </p>
  </div>
  <div
    class="flex"
    [class.justify-content-end]="isTextRight">
    <div
      class="text-gray-400 flex-none"
      [innerHtml]="project.deadlineDelayRequest.commentary | truncate: 60:true | safeHtml"
      [pTooltip]="project.deadlineDelayRequest.commentary"
      tooltipPosition="bottom"
      [escape]="false"></div>
  </div>
</div>

<div *ngIf="isResponsible && !project.deadlineDelayRequest">
  <p
    class="cursor-pointer hover:frm-color-blue-light"
    (click)="opDeadline.opDeadline.toggle($event)"
    pTooltip="Перенести дедлайн"
    [showDelay]="300"
    tooltipPosition="top">
    {{ project.deadline ? (project.deadline | date: 'EEE, dd MMMM yyyy') : 'Отсутствует' }}
  </p>

  <crm-project-change-deadline-form-overlay-panel #opDeadline></crm-project-change-deadline-form-overlay-panel>
</div>

<p *ngIf="!((isCreator && project.deadlineDelayRequest) || isResponsible)">
  {{ project.deadline ? (project.deadline | date: 'EEE, dd MMMM yyyy') : 'Отсутствует' }}
</p>
